import React from 'react';
import IconButton, { Props as IconButtonProps } from '../IconButton/IconButton';

import styles from './FloatingIconButton.module.scss';
import classNames from 'classnames';

export interface Props extends IconButtonProps {
  size: 'small' | 'regular' | 'large' | 'extra-large';
  type: 'primary' | 'primary-inverse';
  icon: string;
}

const FloatingIconButton: React.FC<Props> = ({ className, type, ...props }) => {
  return (
    <IconButton
      {...props}
      type={type}
      iconSize={24}
      className={classNames(styles.container, styles[type], className, { [styles.disabled]: props.disabled })}
    />
  );
};

export default FloatingIconButton;
